export default "__VITE_ASSET__77OsvO_X__"